import React, { Component } from "react";
import moment from "moment";
import { ToastContainer } from "react-toastr";
import { Link } from "react-router-dom";
import axios from "../utils/axios";
import $ from "jquery";
import { reload } from "../utils/datatable";
import {
  APPROVE_STATUS,
  MONTH,
  ROLE,
  SEND_STATUS,
  URL_S003,
  URL_S004,
  URL_S006,
  URL_S007,
  URL_S009,
  URL_S010,
} from "../utils/constants";
import {
  formatApproveStatus,
  formatApproveStatusClass,
  formatDate,
  formatSendStatus,
  formatSendStatusClass,
  isDateAvailable,
} from "../utils/format";
import { getUserInfo } from "../utils/auth";
import Sent from "../assets/send.png";
import Pending from "../assets/pending.png";
import Approved from "../assets/approved.png";
import Rejected from "../assets/rejected.png";

function datatable(path) {
  return $("#example2").DataTable({
    responsive: true,
    autoWidth: false,
    paging: true,
    lengthChange: true,
    searching: true,
    ordering: false,
    stateSave: true,
    columns:
      path === URL_S006 || path === URL_S003
        ? [
            { width: "3%" },
            { width: "7%" },
            { width: "5%" },
            { width: "17%" },
            { width: "6%" },
            { width: "7%" },
            { width: "4%" },
            { width: "8%" },
            { width: "7%" },
            { width: "7%" },
            { width: "7%" },
            { width: "15%" },
            { width: "5%" },
          ]
        : [
            { width: "3%" },
            { width: "7%" },
            { width: "17%" },
            { width: "8%" },
            { width: "8%" },
            { width: "4%" },
            { width: "9%" },
            { width: "7%" },
            { width: "8%" },
            { width: "7%" },
            { width: "17%" },
            { width: "5%" },
          ],
    footerCallback: function (row, data, start, end, display) {
      var api = this.api();

      // Remove the formatting to get integer data for summation
      var intVal = function (i) {
        return typeof i === "string"
          ? i !== "-"
            ? i * 1
            : 0
          : typeof i === "number"
          ? i
          : 0;
      };

      let num = 3;
      if (path === URL_S006 || path === URL_S003) {
        num = 4;
      }
      for (let i = num; i < 7; i++) {
        // Total over all pages
        let total = api
          .column(i)
          .data()
          .reduce(function (a, b) {
            return intVal(a) + intVal(b);
          }, 0);
        // Update footer
        $(api.column(i).footer()).html(total);
      }
    },
  });
}

class S006 extends Component {
  constructor(props) {
    super(props);
    const id = this.props.match.params.id || "1";
    this.state = {
      id,
      name: "",
      monthText: this.props.location.state
        ? this.props.location.state.month
        : moment().format("MM-YYYY"),
      department_name: "",
      departments: [],
      timesheets: [],
      showSave: false,
      page: this.props.location.pathname.slice(0, 10),
    };
  }

  getDepartments = async () => {
    try {
      const info = getUserInfo();
      let path;
      if (this.state.page === URL_S006) {
        if (info.userRole === ROLE.admin) {
          path = `/departments/actives`;
        } else {
          path = `/departments/approve-by/user/${info.userId}`;
        }
      } else {
        path = `/departments/actives`;
      }
      const response = await axios()
        .get(path)
        .then((res) => {
          console.log(res);
          return res.data;
        });
      this.setState({ departments: response });
    } catch (err) {
      console.log(err);
    }
  };

  getDepartmentTimesheet = async (month) => {
    const id = this.state.id;
    const sent = this.state.page === URL_S003 ? "/user-is-null" : "/send/Sent";
    return await axios()
      .get(`/timesheets/department/${id}/month/${month}` + sent)
      .then((res) => {
        console.log(res);
        return res.data;
      });
  };

  componentDidMount = async () => {
    this.getDepartments();
    let month, year;
    if (this.props.location.state) {
      month = this.props.location.state.month.slice(0, 2);
      year = this.props.location.state.month.slice(3, 7);
      this.setState({ monthText: this.props.location.state.month });
    } else {
      month = this.state.monthText.slice(0, 2);
      year = this.state.monthText.slice(3, 7);
    }
    let timesheets = await this.getDepartmentTimesheet(year + month);
    //filtered timesheets with unavailable working date
    timesheets = timesheets.filter((item) =>
      isDateAvailable(item.hireDate, item.resignDate, item.work_date)
    );
    if (timesheets.length > 0) {
      timesheets.sort((a, b) => -b.work_date.localeCompare(a.work_date));
      let timesheetsGroupedByDate = [];
      let index = 0;
      do {
        //group timesheets by date
        let filtered = timesheets.filter(
          (item) =>
            item.work_date.slice(0, 10) === timesheets[0].work_date.slice(0, 10)
        );
        filtered[0].isAllApproved = true;
        filtered[0].isAllSent = true;
        //slice the grouped elements out
        filtered.forEach((item) => {
          timesheets.splice(
            timesheets.findIndex((e) => e.id === item.id),
            1
          );
          if (item.approve_status === APPROVE_STATUS.pending) {
            filtered[0].isAllApproved = false;
          }
          if (
            item.send_status === SEND_STATUS.pending ||
            item.send_status === null
          ) {
            filtered[0].isAllSent = false;
          }
        });
        filtered.sort((a, b) => -b.first_name.localeCompare(a.first_name));
        filtered[0].isShowingDate = true;
        filtered[0].index = index + 1;
        timesheetsGroupedByDate.push(filtered);
        index++;
      } while (timesheets.length > 0);
      timesheetsGroupedByDate.map((e) => (timesheets = timesheets.concat(e)));
    }
    console.log(timesheets);
    this.setState({ timesheets });

    datatable(this.state.page);
    this.setState({ uncheckedNo: $("input:checkbox:not(:checked)").length });
  };

  _handleChange = (event) => {
    this.setState({ [event.target.id]: event.target.value });
  };

  _handleMonthChange = (event) => {
    let monthText;
    if (event.target.id === "month") {
      monthText = event.target.value + this.state.monthText.slice(2, 7);
    } else {
      monthText = this.state.monthText.slice(0, 3) + event.target.value;
    }
    this.setState({ monthText });
  };

  _handleSearch = async (e = null) => {
    if (e) e.preventDefault();
    const month = this.state.monthText.slice(0, 2);
    const year = this.state.monthText.slice(3, 7);
    const id = this.state.id;
    reload(this.props.history, this.state.page + `/${id}`, {
      month: `${month}-${year}`,
    });
  };

  _handleSaveApproved = async (e) => {
    e.preventDefault();
    try {
      let approvedDays = [];
      $("input:checkbox:checked").each(function () {
        approvedDays.push(this.id.slice(11, 40));
      });
      let approvedTimesheets = [];
      for (let i = 0; i < approvedDays.length; i++) {
        let approvedTimesheetsByDay = this.state.timesheets.filter(
          (e) =>
            e.work_date === approvedDays[i] &&
            e.approve_status === APPROVE_STATUS.pending
        );
        approvedTimesheets = approvedTimesheets.concat(approvedTimesheetsByDay);
      }
      for (let i = 0; i < approvedTimesheets.length; i++) {
        await axios()
          .put(`/timesheets/${approvedTimesheets[i].id}`, {
            approveStatus: APPROVE_STATUS.approved,
            approveDate: Date.now(),
          })
          .then((res) => {
            console.log(res);
            return res.data;
          });
      }
      this.container.success(`Approved all successfully`, null, {
        timeOut: 500,
      });
    } catch (err) {
      this.container.error(err.message);
      console.log(err);
    }
    this._handleSearch();
  };

  _handleSaveSent = async (e) => {
    e.preventDefault();
    try {
      let sentDays = [];
      $("input:checkbox:checked").each(function () {
        sentDays.push(this.id.slice(7, 40));
      });
      let sentTimesheets = [];
      for (let i = 0; i < sentDays.length; i++) {
        let sentTimesheetsByDay = this.state.timesheets.filter(
          (e) =>
            e.work_date === sentDays[i] && e.send_status === SEND_STATUS.pending
        );
        sentTimesheets = sentTimesheets.concat(sentTimesheetsByDay);
      }
      let notValidNames = [];
      sentTimesheets.forEach((item) => {
        if (
          +item.work_minutes + +item.non_perform_minutes !== 480 &&
          item.isHoliday === false
        ) {
          notValidNames.push(item.first_name + " " + item.last_name);
        }
      });
      if (notValidNames.length > 0) {
        throw {
          message:
            "The sum between work hours and non-perform hours in a timesheet is not 8 hours: \r\n[" +
            notValidNames.join(",") +
            "]",
        };
      }
      for (let i = 0; i < sentTimesheets.length; i++) {
        await axios()
          .put(`/timesheets/${sentTimesheets[i].id}`, {
            sendStatus: SEND_STATUS.sent,
            sendDate: Date.now(),
            approveStatus: APPROVE_STATUS.pending,
            approveDate: Date.now(),
            remark: null,
          })
          .then((res) => {
            console.log("here");
            console.log(res);
            return res.data;
          });
      }
      this.container.success(`Sent all successfully`, null, {
        timeOut: 500,
      });
      this._handleSearch();
    } catch (err) {
      this.container.error(err.message, null, { timeOut: 5000 });
      console.log(err);
    }
  };

  checkboxChange = (e) => {
    if (this.state.uncheckedNo !== $("input:checkbox:not(:checked)").length) {
      this.setState({ showSave: true });
    } else {
      this.setState({ showSave: false });
    }
  };

  render() {
    return (
      <div>
        <ToastContainer
          ref={(ref) => (this.container = ref)}
          className="toast-top-right"
        />
        {/* Main content */}
        <section className="content m-2">
          <div className="row mx-0">
            <div className="col">
              <div className="card">
                <div className="card-header">
                  <form className="d-flex flex-row mx-0">
                    <div className="input-group col-3">
                      <div className="input-group-prepend">
                        <span className="input-group-text">Department</span>
                      </div>
                      <select
                        type="text"
                        className="form-control"
                        id="id"
                        placeholder="department"
                        value={this.state.id}
                        onChange={this._handleChange}
                      >
                        {this.state.departments.map((item) => {
                          let isS006 = this.state.page === URL_S006;
                          let isAdmin = getUserInfo().userRole === ROLE.admin;
                          return (
                            <option
                              key={
                                isS006
                                  ? isAdmin
                                    ? item.id
                                    : item.department_id
                                  : item.id
                              }
                              value={
                                isS006
                                  ? isAdmin
                                    ? item.id
                                    : item.department_id
                                  : item.id
                              }
                            >
                              {isS006
                                ? isAdmin
                                  ? item.name
                                  : item.department_name
                                : item.name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="input-group col-3">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="far fa-calendar-alt" />
                        </span>
                      </div>
                      <select
                        type="text"
                        className="form-control"
                        id="month"
                        value={this.state.monthText.slice(0, 2)}
                        onChange={this._handleMonthChange}
                      >
                        {MONTH.map((item, index) => {
                          let value;
                          if (index + 1 < 10) {
                            value = "0" + (+index + 1);
                          } else {
                            value = index + 1;
                          }
                          return (
                            <option key={index} value={value}>
                              {item}
                            </option>
                          );
                        })}
                      </select>
                      <select
                        type="text"
                        className="form-control"
                        id="year"
                        value={this.state.monthText.slice(3, 7)}
                        onChange={this._handleMonthChange}
                      >
                        <option key="3" value={+moment().format("YYYY") - 1}>
                          {+moment().format("YYYY") - 1}
                        </option>
                        <option key="2" value={+moment().format("YYYY")}>
                          {+moment().format("YYYY")}
                        </option>
                        <option key="1" value={+moment().format("YYYY") + 1}>
                          {+moment().format("YYYY") + 1}
                        </option>
                      </select>
                    </div>
                    <div className="input-group-append col-1">
                      <button
                        type="submit"
                        className="btn btn-outline-primary"
                        onClick={this._handleSearch}
                      >
                        <i className="fas fa-search" />
                      </button>
                    </div>
                    {/* /.input group */}
                    {this.state.page === URL_S006 && this.state.showSave ? (
                      <div className="col align-self-end">
                        <button
                          onClick={(e) => {
                            this._handleSaveApproved(e);
                          }}
                          className="btn btn-success float-right"
                        >
                          Approve
                        </button>
                      </div>
                    ) : null}
                    {this.state.page === URL_S003 && this.state.showSave ? (
                      <div className="col align-self-end">
                        <button
                          onClick={(e) => {
                            this._handleSaveSent(e);
                          }}
                          className="btn btn-success float-right"
                        >
                          Send
                        </button>
                      </div>
                    ) : null}
                  </form>
                  {/* /.form group */}
                </div>
                <div className="card-body">
                  <table
                    id="example2"
                    className="table table-bordered table-hover"
                  >
                    <thead>
                      <tr>
                        <th>No.</th>
                        <th>Date</th>
                        {this.state.page === URL_S006 ? <th>Approve</th> : null}
                        {this.state.page === URL_S003 ? <th>Send</th> : null}
                        <th>Name</th>
                        <th>Work Hr.</th>
                        <th>Over Time</th>
                        <th>NP</th>
                        <th>Send Status</th>
                        <th>Send Date</th>
                        <th>AP. Status</th>
                        <th>AP. Date</th>
                        <th>Remark</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    {this.state.timesheets.length > 0 ? (
                      <>
                        <tbody>
                          {this.state.timesheets.map((item, index) => {
                            return (
                              <tr key={index + 1}>
                                <td>{item.isShowingDate ? item.index : ""}</td>
                                <td className={item.isHoliday && "text-danger"}>
                                  {
                                    /*item.isShowingDate
                                    ? formatDate(item.work_date)
                                  : ""*/ formatDate(item.work_date)
                                  }
                                </td>
                                {this.state.page === URL_S006 ? (
                                  <td>
                                    {item.isShowingDate && (
                                      <div className="icheck-success">
                                        {item.isAllApproved ? (
                                          <input
                                            type="checkbox"
                                            id={`isApproved-${item.work_date}`}
                                            checked
                                            disabled
                                          />
                                        ) : (
                                          <input
                                            type="checkbox"
                                            id={`isApproved-${item.work_date}`}
                                            onClick={(e) => {
                                              this.checkboxChange(e.target);
                                            }}
                                          />
                                        )}

                                        <label
                                          htmlFor={`isApproved-${item.work_date}`}
                                        />
                                      </div>
                                    )}
                                  </td>
                                ) : null}
                                {this.state.page === URL_S003 ? (
                                  <td>
                                    {item.isShowingDate && (
                                      <div className="icheck-success">
                                        {item.isAllSent ? (
                                          <input
                                            type="checkbox"
                                            id={`isSent-${item.work_date}`}
                                            checked
                                            disabled
                                          />
                                        ) : (
                                          <input
                                            type="checkbox"
                                            id={`isSent-${item.work_date}`}
                                            onClick={(e) => {
                                              this.checkboxChange(e.target);
                                            }}
                                          />
                                        )}
                                        <label
                                          htmlFor={`isSent-${item.work_date}`}
                                        />
                                      </div>
                                    )}
                                  </td>
                                ) : null}
                                <td>
                                  {item.first_name + " " + item.last_name}
                                </td>
                                <td>{+item.work_minutes / 60 || "-"}</td>
                                <td>{+item.ot_minutes / 60 || "-"} </td>
                                <td>{+item.non_perform_minutes / 60 || "-"}</td>
                                <td
                                  className={formatSendStatusClass(
                                    item.send_status
                                  )}
                                >
                                  {formatSendStatus(item.send_status, 0)}
                                </td>
                                <td>
                                  {item.send_date
                                    ? formatDate(item.send_date)
                                    : "-"}
                                </td>
                                <td
                                  className={formatApproveStatusClass(
                                    item.approve_status
                                  )}
                                >
                                  {formatApproveStatus(item.approve_status, 0)}
                                </td>
                                <td>
                                  {item.approve_date
                                    ? formatDate(item.approve_date)
                                    : "-"}
                                </td>
                                <td>{item.remark || "-"}</td>
                                <td>
                                  <Link
                                    to={{
                                      pathname:
                                        (this.props.location.pathname.slice(
                                          0,
                                          10
                                        ) === URL_S006
                                          ? URL_S007
                                          : this.props.location.pathname.slice(
                                              0,
                                              10
                                            ) === URL_S009
                                          ? URL_S010
                                          : URL_S004) + `/${item.id}`,
                                      state: {
                                        date: item.work_date,
                                        department_id: this.state.id,
                                        name:
                                          item.first_name +
                                          " " +
                                          item.last_name,
                                        empCode: item.emp_code,
                                        employee_id: item.employee_id,
                                        isHoliday: item.isHoliday,
                                      },
                                    }}
                                  >
                                    <button className="btn btn-sm btn-info mr-3">
                                      View
                                    </button>
                                  </Link>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                        <tfoot>
                          <tr>
                            <th
                              colSpan={
                                this.state.page === URL_S006 ||
                                this.state.page === URL_S003
                                  ? "4"
                                  : "3"
                              }
                              style={{ textAlign: "right" }}
                            >
                              Total:
                            </th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th colSpan="6"></th>
                          </tr>
                        </tfoot>
                      </>
                    ) : null}
                  </table>
                </div>
                {/* /.card-body */}
              </div>
              {/* /.card */}
            </div>
            {/* /.col */}
          </div>
          {/* /.row */}
        </section>
      </div>
    );
  }
}

export default S006;
